
angular.module('bmsApp.crm').controller('CrmMainCtrl', [
	'$scope', function (
		$scope) {
		
		$scope.$on('customerIndexUpdated', function (e, customerData) {
			$scope.customerData = customerData;
		});

		$scope.$on('enquiryIndexUpdated', function (e, enquiryData) {
			$scope.enquiryData = enquiryData;
		});

		$scope.$on('prospectIndexActiveUpdated', function (e, prospectDataActive) {
			$scope.prospectDataActive = prospectDataActive;
		});

		$scope.$on('prospectIndexLostUpdated', function (e, prospectDataLost) {
			$scope.prospectDataLost = prospectDataLost;
		});

		$scope.prospectData = {
			tab: 'active'
		};

		$scope.exportCustomers = function () {
			$scope.$broadcast('customerIndexExport', {});
		};

		$scope.exportEnquiries = function () {
			$scope.$broadcast('enquiryIndexExport', {});
		};

		$scope.exportProspectsActive = function () {
			$scope.$broadcast('prospectIndexActiveExport', {});
		};

		$scope.exportProspectsLost = function () {
			$scope.$broadcast('prospectIndexLostExport', {});
		};

		$scope.viewCustomersOnMap = function () {
			$scope.$broadcast('customerIndexViewMap', {});
		};

	}]);
